import { render, staticRenderFns } from "./CartDiscountProductCard.vue?vue&type=template&id=041543a3&scoped=true&"
import script from "./CartDiscountProductCard.vue?vue&type=script&lang=js&"
export * from "./CartDiscountProductCard.vue?vue&type=script&lang=js&"
import style0 from "./CartDiscountProductCard.vue?vue&type=style&index=0&id=041543a3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041543a3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductMaterialSelectView: require('/app/components/product/ProductMaterialSelectView.vue').default,UiSpinner: require('/app/components/UI/UiSpinner.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default})
